<template>
    <PrimeBadge class="search-badge">
        <span
            v-if="icon"
            aria-hidden="true"
            class="search-badge__icon"
            :data-test-id="`${dataTestId}-icon`"
            :style="{ '--search-badge-icon': `url(${icon})` }"
        />
        <span
            class="search-badge__label"
            :data-test-id="`${dataTestId}-label`"
            >{{ label }}</span
        >
    </PrimeBadge>
</template>

<script>
import PrimeBadge from 'primevue/badge'

export default {
    name: 'SearchBadge',

    components: {
        PrimeBadge,
    },

    props: {
        // The prefix the badge's own test ids are built from, so a cell
        // rendering a list of badges can key them by position.
        dataTestId: {
            type: String,
            required: true,
        },
        // Path to an image, painted as a mask so it takes the label's color.
        // Omitted for a badge that is text only.
        icon: {
            type: String,
            required: false,
            default: null,
        },
        label: {
            type: String,
            required: true,
        },
    },
}
</script>

<style scoped lang="scss">
.search-badge.p-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    max-width: 100%;
    height: auto;
    padding: 4px 10px;
    overflow: hidden;
    background: #bdc3db;
    border: 1px solid #414574;
    border-radius: 6px;
    color: #505160;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.2;
}

.search-badge__icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    // Recolor the SVG to match the text: paint with the current color and
    // use the icon file only as an alpha mask.
    background-color: currentColor;
    -webkit-mask: var(--search-badge-icon) no-repeat center / contain;
    mask: var(--search-badge-icon) no-repeat center / contain;
}

.search-badge__label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
